export default "__VITE_ASSET__BWI8ru6e__"